<!-- ================管理端-听评课量表====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">听评课量表管理</div>
        </div>
        <div class="create-content-container scale-wrapper">
            <div class="scale-container">
                <div class="scale-container-l">
                    <el-scrollbar class="scrollbar-container-l">
                        <div class="info-column-container">
                            <div class="column-title">量表模板库</div>
                        </div>
                        <el-table show-overflow-tooltip height="calc(100vh - 240px)" :data="rateScaleList">
                            <el-table-column type="index" align="center" label="序号" width="60" />
                            <el-table-column align="center" label="量表名称" prop="title" />
                            <el-table-column fixed="right" width="120" label="操作" align="center"
                                             class-name="small-padding fixed-width">
                                <template #default="scope">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            <el-button type="primary" size="small">操作</el-button>
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item @click="preview(scope.row)">预览</el-dropdown-item>
                                                <el-dropdown-item @click="addMb(scope.row)">添加</el-dropdown-item>
                                                <el-dropdown-item @click="delMb(scope.row)">删除</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-scrollbar>
                </div>
                <div class="scale-container-r">
                    <el-scrollbar class="scrollbar-container-r">
                        <div class="info-column-container">
                            <div class="column-title">量表信息</div>
                        </div>
                        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                            <el-row justify="center" class="mt10">
                                <el-col :span="12">
                                    <el-form-item label="量表标题" prop="title">
                                        <el-input v-model="form.title" placeholder="最多64个字" maxlength="64" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="问题列表" prop="questionList">
                                        <el-empty v-if="form.questionList.length == 0" description="暂无数据" />
                                        <div class="scale-item-card" v-for="(item, index) in form.questionList" :key="index">
                                            <div v-if="item.type != 3">
                                                <h3 class="item-title"><span style="padding-right: 10px;">{{ index + 1
                                                }}.</span>{{ item.questionName }}<span
                                                        style="padding-left: 10px;color: #999;font-weight: normal;font-size: 14px;">[{{
                                                            item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ?
                                                                '评分' :
                                                                item.type == 4 ? '文字内容'
                                                                    : ''
                                                        }}]</span><span v-if="item.type == 4 && (item.totalScore || item.totalScore == 0)"
                                                        class="item-score">(分值：{{
                                                            item.totalScore }})</span></h3>
                                            </div>
                                            <div v-if="item.type == 3" style="display: flex;">
                                                <div>
                                                    <h3 class="item-title"><span style="padding-right: 10px;">{{ index + 1
                                                    }}.</span>{{ item.questionName }}<span
                                                            style="padding-left: 10px;color: #999;font-weight: normal;font-size: 14px;">[{{
                                                                item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ?
                                                                    '评分' :
                                                                    item.type == 4 ? '文字内容'
                                                                        : ''
                                                            }}]</span><span
                                                            class="item-score">(满分：{{
                                                                item.totalScore }})</span></h3>
                                                </div>
                                            </div>
                                            <div v-if="item.type == 1">
                                                <el-radio-group disabled class="ml-4">
                                                    <el-radio label="1" size="small"
                                                        v-for="(items, indexs) in item.itemList" :key="indexs">
                                                        <span style="color: #333;">{{ items.itemName }}</span><span
                                                            class="item-score">(分值：{{ items.itemValue
                                                            }})</span></el-radio>
                                                </el-radio-group>
                                            </div>
                                            <div v-if="item.type == 2">
                                                <el-checkbox-group disabled class="ml-4">
                                                    <el-checkbox size="small" v-for="(items, indexs) in item.itemList"
                                                        :key="indexs">
                                                        <span style="color: #333;">{{ items.itemName }}</span><span
                                                            class="item-score">(分值：{{ items.itemValue }})</span>
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                            <div v-if="item.type == 4" style="width: 100%;">
                                                <el-input style="width: 100%;" disabled :rows="2" type="textarea"
                                                    placeholder="" />
                                            </div>
                                            <el-row class="item-operate-row">
                                                <el-col :span="4">
                                                    <el-button @click="nextQuestion(index)" type="primary"
                                                        link>在此题后插入新题</el-button>
                                                </el-col>
                                                <el-col :span="20">
                                                    <el-button @click="editQuestion(index)" type="primary" size="small"
                                                        icon="edit">编辑</el-button>
                                                    <el-button @click="copyQuestion(index)" type="primary" size="small"
                                                        icon="documentCopy">复制</el-button>
                                                    <el-button @click="delQuestion(index)" type="primary" size="small"
                                                        icon="delete">删除</el-button>
                                                    <el-button @click="topQuestion(index)" type="primary" size="small"
                                                        icon="top">上移</el-button>
                                                    <el-button @click="bottomQuestion(index)" type="primary" size="small"
                                                        icon="bottom">下移</el-button>
                                                    <el-button @click="zdQues(index)" type="primary" size="small"
                                                        icon="upload">置顶</el-button>
                                                    <el-button @click="zbQues(index)" type="primary" size="small"
                                                        icon="download">置底</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row justify="center" class="mt15">
                                <el-button style="width: 200px;" @click="addQuestion" type="primary">新增评价维度</el-button>
                            </el-row>
                        </el-form>
                    </el-scrollbar>
                </div>
            </div>

            <div class="scale-footer">
                <div class="dis-flex-row-center">
                    <el-button type="info" @click="preview(null)">预 览</el-button>
                    <el-button type="primary" @click="submitForm">保 存</el-button>
                    <el-button @click="backList">取 消</el-button>
                </div>
            </div>
        </div>

        <el-dialog :title="editNum != null ? '编辑评价维度' : '新增评价维度'" v-model="addQuse" width="60%">
            <el-form ref="quseform" :model="addQuseForm" :rules="addQuesrules" label-width="120px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="addQuseForm.type == 3 ? '考核项目' : '评价维度名称'" prop="questionName">
                            <el-input type="textarea" v-model="addQuseForm.questionName" placeholder="最多1000个字"
                                maxlength="1000" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="题型" prop="type">
                            <el-select @change="setType" style="width: 100%;" v-model="addQuseForm.type" placeholder="请选择题型">
                                <el-option v-for="item in quesTypeList" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                            <span style="color:red;" v-if="addQuseForm.type == 4">文字内容不支持设置分数</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="addQuseForm.type == 3">
                    <el-col :span="12">
                        <el-form-item label="选项分数" prop="totalScore">
                            <el-input-number :disabled="addQuseForm.type == 4" step-strictly v-model="addQuseForm.totalScore" :min="0" :max="100" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="addQuseForm.type == 1 || addQuseForm.type == 2">
                    <el-col>
                        <el-form-item label="选项" prop="quesXXList">
                            <el-table ref="quesXXList" border :data="addQuseForm.itemList" style="width: 100%"
                                max-height="250">
                                <el-table-column prop="itemName" label="选项文字">
                                    <template #default="scope">
                                        <el-input v-model="scope.row.itemName" placeholder="最多32个字" maxlength="32" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="itemValue" label="选项分数">
                                    <template #default="scope">
                                        <el-input-number step-strictly v-model="scope.row.itemValue" :min="0" :max="100" />
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" label="操作" width="200">
                                    <template #default="scope">
                                        <el-button link type="primary" size="small"
                                            @click.prevent="deleteRow(scope.$index)">
                                            删除
                                        </el-button>
                                        <el-button link type="primary" size="small"
                                            @click.prevent="addQuesRow(scope.$index)">
                                            增加
                                        </el-button>
                                        <el-button link type="primary" size="small"
                                            @click.prevent="moveUpRow(scope.$index)">
                                            上移
                                        </el-button>
                                        <el-button link type="primary" size="small" @click.prevent="downRow(scope.$index)">
                                            下移
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button plain type="primary" class="mt10" style="width: 100%"
                                @click="onAddItem">增加</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <div class="dis-flex-row-center">
                    <el-button type="primary" @click="addQuesSumbit">确 定</el-button>
                    <el-button @click="addQuse = false">取 消</el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog :title="previewData.title ? previewData.title : '预览'" v-model="previewShow" width="60%">
            <div class="mb30" v-for="(item, index) in previewData.questionList" :key="index">
                <div class="mb15" v-if="item.type != 3">
                    <h3 style="margin: 0 0;"><span style="padding-right: 10px;">{{ index + 1
                    }}.</span>{{ item.questionName }}
                        <span style="padding-left: 10px;color: #999;font-weight: normal;font-size: 14px;">[{{
                            item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ? '评分' : item.type == 4 ? '文字内容'
                                : ''
                        }}]</span><span v-if="item.type == 4 && (item.totalScore || item.totalScore == 0)"
                            style="color: #efa030;font-weight: normal;font-size: 14px;">(分值：{{
                                item.totalScore }})</span>
                        <span v-if="item.type == 3" style="color: #efa030;font-weight: normal;font-size: 14px;">(满分：{{
                            item.totalScore }})</span>
                    </h3>
                </div>
                <div v-if="item.type == 1">
                    <el-radio-group disabled class="ml-4">
                        <el-radio label="1" size="small" v-for="(items, indexs) in item.itemList" :key="indexs">
                            <span style="color: #333;">{{ items.itemName }}</span><span style="color: #efa030;">(分值：{{
                                items.itemValue }})</span></el-radio>
                    </el-radio-group>
                </div>
                <div v-if="item.type == 2">
                    <el-checkbox-group disabled class="ml-4">
                        <el-checkbox size="small" v-for="(items, indexs) in item.itemList" :key="indexs">
                            <span style="color: #333;">{{ items.itemName }}</span><span style="color: #efa030;">(分值：{{
                                items.itemValue }})</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
                <div v-if="item.type == 4" style="width: 100%;">
                    <el-input style="width: 100%;" disabled :rows="2" type="textarea" placeholder="" />
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { rateScaleCreate, rateScaleList, rateScaleInfo, rateScaleDel } from "@/api/admin/evaluation"

export default {
    name: "evaLessonScale",
    components: {},
    data() {
        return {
            rateScaleList: [],
            form: {
                title: '',
                questionList: []
            },
            addQuesrules: {
                questionName: [
                    { required: true, message: "请输入评价维度名称", trigger: "blur" },
                ],
                totalScore: [
                    { required: true, message: "请输入选项分数", trigger: "blur" },
                ],
                type: [
                    { required: true, message: "请选择题型", trigger: "change" },
                ],
                quesXXList: [
                    { required: true, validator: this.checkQUXXValidator }
                ]
            },
            rules: {
                title: [
                    { required: true, message: "请输入量表标题", trigger: "blur" },
                ],
            },
            quesTypeList: [
                { label: '单选', value: 1 },
                { label: '多选', value: 2 },
                { label: '评分', value: 3 },
                { label: '文字内容', value: 4 },
            ],
            addQuse: false,
            addQuseForm: {
                questionName: '',
                type: 1,
                itemValue: '',
                itemList: [
                    { itemName: '', itemNo: 1, itemValue: 1 }
                ],
                totalScore: 0
            },
            editNum: null,
            createNum: null,
            previewData: {},
            previewShow: false,
            scaleType: 1
        };
    },
    created() {
    },
    mounted() {
        this.getRateScaleList();
    },
    computed: {},
    methods: {
        setType() {
            if (this.addQuseForm.type == 3 || this.addQuseForm.type == 4) {
                this.addQuseForm.totalScore = 0;
            }
        },
        delMb(item) {
            this.$confirm('确定删除该模板?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                rateScaleDel({ scaleId: item.scaleId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.$message.success('删除成功')
                        this.getRateScaleList()
                    } else {
                        this.$message.error(res.data.msg || '操作失败')
                    }
                })
            });
        },
        preview(item) {
            if (item) {
                rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.previewData = res.data.data;
                        this.previewShow = true;
                    }
                })
            } else {
                this.previewData = JSON.parse(JSON.stringify(this.form))
                this.previewShow = true;
            }
        },
        addMb(item) {
            rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.form = res.data.data;
                }
            })
        },
        getRateScaleList() {
            rateScaleList({ scaleType: this.scaleType }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.rateScaleList = res.data.data || [];
                }
            })
        },
        nextQuestion(index) {
            this.createNum = index;
            this.editNum = null;
            this.addQuseForm = {
                questionName: '',
                type: 1,
                itemList: [
                    { itemName: '', itemNo: 1, itemValue: 1 }
                ],
                totalScore: 0
            }
            this.addQuse = true;
        },
        editQuestion(index) {
            this.addQuseForm = JSON.parse(JSON.stringify(this.form.questionList[index]));
            this.editNum = index;
            this.createNum = null;
            this.addQuse = true;
        },
        checkQUXXValidator(rule, value, callback) {
            var result = true;
            for (var i = 0; i < this.addQuseForm.itemList.length; i++) {
                var e = this.addQuseForm.itemList[i];
                if (e.itemName == '' || (e.itemValue == '' && e.itemValue != 0)) {
                    result = false
                    break;
                }
            }
            if (result) {
                callback()
            } else {
                callback(new Error('请填写完整信息'))
            }
        },
        deleteRow(index) {
            if (this.addQuseForm.itemList.length == 1) {
                this.$message.error("不能全部删除")
            } else {
                this.addQuseForm.itemList.splice(index, 1)
            }
        },
        copyQuestion(index) {
            this.form.questionList.splice(index, 0, JSON.parse(JSON.stringify(this.form.questionList[index])))
        },
        delQuestion(index) {
            this.form.questionList.splice(index, 1)
        },
        addQuesRow(index) {
            this.addQuseForm.itemList.splice(index, 0, { itemName: '', itemNo: 1, itemValue: 1 })
        },
        zdQues(index) {
            if (index != 0) {
                this.form.questionList.unshift(this.form.questionList.splice(index, 1)[0]);
            }
        },
        zbQues(index) {
            if (index != this.form.questionList.length - 1) {
                this.form.questionList.push(this.form.questionList.splice(index, 1)[0]);
            }
        },
        moveUpRow(index) {
            if (index != 0) {
                this.addQuseForm.itemList[index] = this.addQuseForm.itemList.splice(index - 1, 1, this.addQuseForm.itemList[index])[0];
            } else {
                this.addQuseForm.itemList.push(this.addQuseForm.itemList.shift());
            }
        },
        downRow(index) {
            if (index != this.addQuseForm.itemList.length - 1) {
                this.addQuseForm.itemList[index] = this.addQuseForm.itemList.splice(index + 1, 1, this.addQuseForm.itemList[index])[0];
            } else {
                this.addQuseForm.itemList.unshift(this.addQuseForm.itemList.splice(index, 1)[0]);
            }
        },
        topQuestion(index) {
            if (index != 0) {
                this.form.questionList[index] = this.form.questionList.splice(index - 1, 1, this.form.questionList[index])[0];
            } else {
                this.$message.error('第一题不能上移')
            }
        },
        bottomQuestion(index) {
            if (index != this.form.questionList.length - 1) {
                this.form.questionList[index] = this.form.questionList.splice(index + 1, 1, this.form.questionList[index])[0];
            } else {
                this.$message.error('最后一题不能下移')
            }
        },
        onAddItem() {
            this.addQuseForm.itemList.push(
                { itemName: '', itemNo: 1, itemValue: 1 }
            )
        },
        addQuestion() {
            this.editNum = null;
            this.createNum = null;
            this.addQuseForm = {
                questionName: '',
                type: 1,
                itemList: [
                    { itemName: '', itemNo: 1, itemValue: 1 }
                ],
                totalScore: 0
            }
            this.addQuse = true;
        },
        addQuesSumbit() {
            this.$refs["quseform"].validate(valid => {
                if (valid) {
                    this.addQuseForm.itemList.forEach((e, i) => {
                        e.itemNo = i;
                    })
                    if (this.editNum != null) {
                        this.form.questionList[this.editNum] = this.addQuseForm
                    } else if (this.createNum != null) {
                        this.form.questionList.splice(this.createNum + 1, 0, this.addQuseForm)
                    } else {
                        this.form.questionList.push(this.addQuseForm)
                    }
                    this.addQuse = false;
                }
            });
        },
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.form.scaleType = this.scaleType;
                    var obj = JSON.parse(JSON.stringify(this.form))
                    obj.questionList.forEach(e => {
                        if (e.type == 1 || e.type == 2) {
                            e.totalScore = ''
                        }
                        if (e.type == 4 || e.type == 3) {
                            delete e.itemList
                        }
                    })
                    rateScaleCreate(obj).then(res => {
                        if (res.data && res.data.code == 1) {
                            this.$message.success('保存成功')
                            this.form = {
                                title: '',
                                questionList: []
                            }
                            this.getRateScaleList()
                        } else {
                            this.$message.error(res.data.msg || '操作失败')
                        }
                    })
                }
            });
        },
        backList() {
            this.$router.push({ path: "/evaLesson" });
        },
    }
};
</script>

<style scoped>
.scale-wrapper {
    width: 100%;
    height: calc(100% - 50px);
    padding: 0;
    display: flex;
    flex-direction: column;
}

.scale-container {
    width: 100%;
    flex: 1;
    display: flex;
    gap: 10px;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
    overflow: hidden;
}

.scale-container-l {
    height: 100%;
    width: 300px;
    border: 1px solid #e5e8ec;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
}

.scrollbar-container-l {
    height: 100%;
    width: 100%;
}

.scale-container-r {
    height: 100%;
    flex: 1;
    border: 1px solid #e5e8ec;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
}

.scrollbar-container-r {
    height: 100%;
    width: 100%;
}

.info-column-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #377f7f;
    margin-bottom: 10px;
}

.column-title {
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #377f7f;
    font-size: 16px;
    text-indent: 5px;
    padding-right: 15px;
}

.column-extra {
    margin-left: auto;
    padding-right: 10px;
}

.scale-tag {
    height: 24px;
    border: 1px solid #377f7f;
    line-height: 24px;
    color: #377f7f;
    cursor: pointer;
}

.scale-item-card {
    border: 1px solid #e5e8ec;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fafafa;
    box-sizing: border-box;
}

.item-title {
    margin: 0 0 8px 0;
    font-size: 16px;
    color: #333;
}

.item-score {
    color: #efa030;
    font-weight: normal;
    font-size: 14px;
}

.item-operate-row {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e5e8ec;
}

.scale-footer {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}

.dis-flex-row-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.mt10 {
    margin-top: 10px;
}

/deep/ .el-dialog__body {
    padding: 10px 20px !important;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

@media (max-width: 1024px) {
    .scale-container {
        flex-direction: column;
        overflow-y: auto;
    }
    .scale-container-l {
        width: 100%;
        height: 40%;
    }
    .scale-container-r {
        width: 100%;
        height: auto;
        min-height: 50%;
    }
}
</style>
